module.exports = __webpack_public_path__ + "img/Income-and-savings.bb7c05dc.svg";